import { cx, api, rx } from '../../../api';
import { ofType } from 'redux-observable';
import { exhaustMap, map as rxmap, takeUntil } from 'rxjs/operators';
import { ActionGeneratorBuilder, errorMap } from '../../actions';

const defaultState = {
	map: null, // unitId => cx.ods.meta.Unit
	pending: false,
	error: null
};

const actions = new ActionGeneratorBuilder('metaUnits')
	.subtype('units', units => units.request().success('classifier').fail().cancel())
	.build()
;

// ---------------------------------------------------------

function reducer(state = defaultState, action) {
	switch (action.type) {
		case actions.units.request.type:
			return {
				...state,
				pending: true
			};
		case actions.units.success.type:
			return {
				...state,
				map: cx.i.hash(action.classifier, (unit) => unit.unitId),
				pending: false,
				error: null
			};
		case actions.units.fail.type:
			return {
				...state,
				pending: false,
				error: action.errorMessage
			};
		default:
			return state;
	}
}


// ---------------------------------------------------------

const epic = (action$) => {
	return action$.pipe(
		ofType(actions.units.request.type),
		exhaustMap(action =>
			rx(api.meta.classifier.unit).pipe(
				rxmap(operation => actions.units.success({ classifier: operation.response() })),
				errorMap(actions.units.fail),
				takeUntil(action$.pipe(ofType(actions.units.cancel.type))),
			)
		),
	)
}

// ---------------------------------------------------------

export { actions, reducer, epic };
